import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fuName'
})
export class FileUploadNamePipe implements PipeTransform {
	transform(value: any, args?: any): any {
		if (value && value.length) {
			const arr = value.split('/');
			return arr[arr.length - 1];
		} else {
			return value;
		}
	}
}
